module.exports = __webpack_public_path__ + "img/settingInfo.76d4ef5c.svg";